import React, { Component } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
export default class About extends Component {
    componentDidMount() {
        AOS.init({
            easing: 'ease',
            duration : 2000
        });
    }
    render(){
        return (
                <section className="about" id="about">
                    <div className="container">
                        <div className="profile-img" data-aos="fade-right">
                            <div className="about-details">
                                <div className="about-heading">
                                    <h1> About</h1>
                                    <h6> Myself</h6>
                                </div>
                            </div>
                            <img src={`${process.env.PUBLIC_URL}/images/patrol.jpg`} alt="" />
                        </div>
                        <div className="about-details">
                            <p> 
                                Hi ! I'm a 25 years old engineer passionate about web development, coding and algorithm. I've been working
                                for an offshore and subsea construction Company since October 2018 and made a couple of dashboard applications.
                                These dashboards are made to analyse flaws found by Automatic Ultrasonic Systems on welds performed
                                on pipelines. 
                                I've always been very attracted by coding, web development and I'm currently seeking for a Junior Fullstack developer position
                                in a challenging environment.
                            <br/>
                            <br/>
                                Oh ! I also made this picture of the Patrol 1 back in the day during a intership for a small company in UK. This
                                image is rendered from a 3D environment I built with Blender 3D.
                            </p>

                            <div className="social-media">
                                <ul className="nav-list">
                                <li>
                                    <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/henripierre.goder/" className="icon-link">
                                        <i className="fab fa-facebook-square" data-aos="fade-up"></i>
                                    </a>
                                    <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/GoderHenri" className="icon-link">
                                        <i className="fab fa-twitter-square" data-aos="fade-down"></i>
                                    </a>
                                    <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/henri-pierre-goder/" className="icon-link" >
                                        <i className="fab fa-linkedin" data-aos="fade-up"></i>
                                    </a>
                                </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
        )
    }
}
